// 案件列表頁面翻譯
export default {
  // 頁面標題
  pageTitle: "研判分析-案件分析",
  switchToOldVersion: "切到舊版本",
  switchToNewVersion: "切到新版本",

  // 頂部按鈕
  allCases: "所有案件",
  myCases: "我的案件",
  createCase: "新建案件",

  // 搜索表單
  searchForm: {
    caseNamePlaceholder: "請輸入案件名稱",
    creatorNamePlaceholder: "請輸入創建人姓名",
    startDate: "開始日期",
    endDate: "結束日期",
    rangeSeparator: "→",
  },

  // 統計信息
  totalData: "共計",
  dataUnit: "條數據",

  // 表格列
  tableColumns: {
    index: "序號",
    caseName: "案件名稱",
    caseDescription: "案件說明",
    caseType: "案件類型",
    creator: "創建人",
    createTime: "創建時間",
    updateTime: "更新時間",
    operation: "操作",
  },

  // 操作按鈕
  actions: {
    edit: "修改",
    analyze: "分析",
    delete: "刪除",
  },

  // 確認對話框
  confirmDialog: {
    deleteTitle: "刪除確認",
    deleteMessage: "此操作將永久刪除{caseName}案件, 是否確定?",
    confirmButton: "確定",
    cancelButton: "取消",
  },

  // 消息提示
  messages: {
    deleteSuccess: "刪除成功",
    deleteCancelled: "已取消刪除",
    noPermission: "您沒有權限訪問該頁面",
  },

  // 加載狀態
  loading: "拚命加載中",

  // 空狀態
  emptyText: "暫無數據",
};
